/**
 * Shared helpers for the federation runtime plugins
 * (`dynamic-remote-plugin` and `remote-resilience-plugin`). Kept free of
 * transform-only dependencies so the resilience plugin can import it without
 * pulling in `domains.js`.
 */

/**
 * Get current environment from process.env or window.
 * - Server: use bracket access so bundlers don't inline at build time.
 * - Client: window.__CURRENT_ENV__ is set when App mounts; Module Federation can run before that,
 *   so we also read from __NEXT_DATA__.props.currentEnv (set by getInitialProps in the initial HTML).
 */
export const getCurrentEnv = (isServer) => {
    if (isServer) {
        if (typeof process === 'undefined' || !process.env) return undefined;
        const env = process.env['CURRENT_ENV'];
        return env || 'prod';
    }
    if (typeof window === 'undefined') return undefined;
    if (window.__CURRENT_ENV__) return window.__CURRENT_ENV__;
    const fromNextData = window.__NEXT_DATA__?.props?.currentEnv;
    return fromNextData || 'prod';
};

/**
 * Get hostname from current context
 */
export const getHostname = (isServer, logger) => {
    let hostname = 'localhost'; // default fallback
    try {
        if (!isServer) {
            // Client-side: use window.location
            hostname = window.location.hostname.split(':')[0];
        } else {
            hostname = global.__incrementalCache.requestHeaders.host.split(':')[0];
        }
    } catch (e) {
        logger.error(`🔍 Error determining hostname: ${e.message}`);
    }
    return hostname;
};
